import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { WorkItemTypes } from 'common/workitems/constants/workitem-types';
import { RxEmitter } from 'common/rxjs/rx-emitter';
import { MessageBusEvents } from 'common/common/constants/message-bus-events';
import { ThemeServiceHelper } from 'common/theme/service.helper';
import { UserPermissionService } from 'shared/services/user-permissions/user-permission.service';
import { AccountPermissionType } from 'common/common/constants/account-permission-type';

@Component({
  selector: 'app-work-item-preview',
  templateUrl: './work-item-preview.component.html',
  styleUrls: ['./work-item-preview.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WorkItemPreviewComponent implements OnInit, OnChanges {
  @Input()
  workItemId: string;

  @Input()
  workItemType: WorkItemTypes;

  @Input()
  tabName: string;

  @Input()
  isClosed: boolean;

  @Output()
  closeAction: EventEmitter<void> = new EventEmitter();

  public isDetailedDataVisible: boolean = true;
  public isWorkItemPreviewVisible: boolean = true;
  public isVisitorHistoryVisible: boolean = true;
  public themeClass: string;
  public hasAssignmentHistoryPermission: boolean = false;

  constructor(private _rxEmitter: RxEmitter,
              private _changeDetector: ChangeDetectorRef,
              private _userPermissionService: UserPermissionService) { }

  get isChat(): boolean {
    return this.workItemType === WorkItemTypes.CHAT;
  }

  get isEmail(): boolean {
    return this.workItemType === WorkItemTypes.EMAIL;
  }

  get isMessaging(): boolean {
    return this._isFacebook() || this._isSms() || this._isAsyncMessage();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.workItemId && changes.workItemId.currentValue !== changes.workItemId.previousValue) {
      this.themeClass = ThemeServiceHelper.getCssClass(this.workItemId);
    }
  }

  ngOnInit(): void {
    this._rxEmitter.subscribe(MessageBusEvents.PreviewInfoPanelVisibility, (newValue) => {
      this.isDetailedDataVisible = newValue;
      this._changeDetector.detectChanges();
    });

    this._rxEmitter.subscribe(MessageBusEvents.PreviewWorkLaneVisibility, (newValue) => {
      this.isWorkItemPreviewVisible = newValue;
      this._changeDetector.detectChanges();
    });

    this._rxEmitter.subscribe(MessageBusEvents.PreviewVisitorHistoryVisibility, (newValue) => {
      this.isVisitorHistoryVisible = newValue;
      this._changeDetector.detectChanges();
    });

    this._checkPermissionForAssignmentHistory();
  }

  closeButtonClicked(): void {
    this.closeAction.emit();
  }

  private _isSms(): boolean {
    return this.workItemType === WorkItemTypes.SMS;
  }

  private _isFacebook(): boolean {
    return this.workItemType === WorkItemTypes.FACEBOOK;
  }

  private _isAsyncMessage(): boolean {
    return this.workItemType === WorkItemTypes.ASYNC_MESSAGE;
  }

  private _checkPermissionForAssignmentHistory(): void {
    this.hasAssignmentHistoryPermission = this._userPermissionService.hasAccountPermissionFor(AccountPermissionType.AssignmentHistory);
  }
}
